import React from "react";
import PropTypes from "prop-types";
import { FormGroup, FormControl, ControlLabel,Checkbox , Row, Col} from "react-bootstrap";
import moment from "moment";
import DatePicker from "react-datepicker";
import Select, { Async } from "react-select";
import InlineError from "../../../messages/InlineError";

class EmployeeFields extends React.Component {
	render() {
		return(
			<React.Fragment>
				<Row>
					<Col md={6}>
						<FormGroup validationState={this.props.errors.reporter_id && "error"}>
							<ControlLabel>Reports to</ControlLabel>
							<Async
								onChange={(option) => { this.props.onAsyncChange(option, "reporter_id"); }}
								name="reporter_id"
								placeholder="Choose user"
								value={this.props.selectedUser}
								labelKey="full_name"
								valueKey="id"
								loadOptions={(e,c) => this.props.handleAsyncSearch(e,"user",`roles=1,2,4&exclude=${this.props.user_id}`,c)}
								clearable
								multi={false}
							/>
							{this.props.errors.reporter_id && <InlineError text={this.props.errors.reporter_id} />}						
						</FormGroup>
					</Col>
					<Col md={6}>
						<FormGroup validationState={this.props.errors.title && "error"}>
							<ControlLabel>Title</ControlLabel>
							<FormControl type="text" name="title" placeholder="Enter title"  value={this.props.formData.title || ""} onChange={this.props.onChange} />
							{this.props.errors.title && <InlineError text={this.props.errors.title} />}
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col md={6}>
						<FormGroup validationState={this.props.errors.start_date && "error"}>
							<ControlLabel>Work start date:</ControlLabel>
							<DatePicker
								selected={this.props.selectedStartDate && moment(this.props.selectedStartDate)}
								onChange={(date)=>this.props.onWorkDateChange(date, "start_date", "selectedStartDate")}
								dateFormat="DD-MM-YYYY"
								className="form-control"
								placeholderText="Choose start date"
							/>
							{this.props.errors.start_date && <InlineError text={this.props.errors.start_date} />}
						</FormGroup>
					</Col>
					<Col md={6}>
						<FormGroup validationState={this.props.errors.end_date && "error"}>
							<ControlLabel>Work end date:</ControlLabel>
							<DatePicker
								selected={this.props.selectedEndDate && moment(this.props.selectedEndDate)}
								onChange={(date)=>this.props.onWorkDateChange(date, "end_date", "selectedEndDate")}
								dateFormat="DD-MM-YYYY"
								className="form-control"
								placeholderText="Choose date"
							/>
							{this.props.errors.end_date && <InlineError text={this.props.errors.end_date} />}
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col md={6}>	
						<FormGroup validationState={this.props.errors.insurance_nr && "error"}>
							<ControlLabel>Insurance Number</ControlLabel>
							<FormControl type="text" name="insurance_nr" placeholder="Enter Insurance Number"  value={this.props.formData.insurance_nr || ""} onChange={this.props.onChange} />
							{this.props.errors.insurance_nr && <InlineError text={this.props.errors.insurance_nr} />}						
						</FormGroup>
					</Col>
					<Col md={6}>
						<FormGroup validationState={this.props.errors.personal_code && "error"}>
							<ControlLabel>Personal Number</ControlLabel>
							<FormControl type="text" name="personal_code" placeholder="Enter Personal Code"  value={this.props.formData.personal_code || ""} onChange={this.props.onChange} />
							{this.props.errors.personal_code && <InlineError text={this.props.errors.personal_code} />}				
						</FormGroup>
					</Col>
				</Row>
				<FormGroup validationState={this.props.errors.bank_account && "error"}>
					<ControlLabel>Bank Account</ControlLabel>
					<FormControl type="text" name="bank_account" placeholder="Enter Bank Account"  value={this.props.formData.bank_account || ""} onChange={this.props.onChange} />
					{this.props.errors.bank_account && <InlineError text={this.props.errors.bank_account} />}		
				</FormGroup>
				{!this.props.isEditPage &&
					<Row>
						<Col md={6} xs={6}>
							<FormGroup validationState={this.props.errors.domestic_salary && "error"}>
								<ControlLabel>Salary</ControlLabel>
								<FormControl type="number" name="domestic_salary" placeholder="Enter salary" value={this.props.formData.domestic_salary || ""} onChange={this.props.onChange}/>
								{this.props.errors.domestic_salary && <InlineError text={this.props.errors.domestic_salary} />}
							</FormGroup>
						</Col>
						<Col md={6} xs={6}>
							<FormGroup validationState={this.props.errors.currency && "error"}>
								<ControlLabel>Currency</ControlLabel>
								<Select
									onChange={(option) => { this.props.onSelectChange(option, "currency"); }}
									name="currency"
									placeholder="Choose currency"
									value={this.props.formData.currency || ""}
									options={this.props.currencies}
									isLoading={this.props.isLoadingCurrencies}
									clearable={false}
									multi={false}
								/>
								{this.props.errors.currency && <InlineError text={this.props.errors.currency} />}
							</FormGroup>
						</Col>
					</Row>
				}
				<FormGroup validationState={this.props.errors.receives_log_emails && "error"}>
					<Checkbox name="receives_log_emails" inline onChange={this.props.onCheckboxChange} checked={this.props.receivesLogEmails}>
						Send email notification about logging hours
					</Checkbox> 
				</FormGroup>		
			</React.Fragment>
		);
	}
};

EmployeeFields.defaultProps = {
	errors: PropTypes.object,
	selectedUser: PropTypes.object,
	onChangeSalaryValue: PropTypes.func,
	onChangeSalaryCurrency: PropTypes.func,
	addNewSalary: PropTypes.func,
	onFromDateChange: PropTypes.func,
	onWorkDateChange: PropTypes.func,
	user_id: null,
	selectedStartDate: null,
	selectedEndDate: null,
	isLoadingCurrencies: false,
	currencies: []
};

EmployeeFields.propTypes = {
	isLoadingCurrencies: PropTypes.bool,
	selectedStartDate: PropTypes.string,
	selectedEndDate: PropTypes.string,
	user_id: PropTypes.string,
	isEditPage: PropTypes.bool.isRequired,
	receivesLogEmails: PropTypes.oneOfType([
		PropTypes.bool,
		PropTypes.number
	]).isRequired,
	formData: PropTypes.shape({
		skills: PropTypes.array,
		title: PropTypes.string,
		domestic_salary: PropTypes.string,
		insurance_nr: PropTypes.string,
		personal_code: PropTypes.string,
		bank_account: PropTypes.string,
		reporter_id: PropTypes.string,
		currency: PropTypes.string,
		receives_log_emails: PropTypes.oneOfType([
			PropTypes.bool,
			PropTypes.number
		]),
		salaries: PropTypes.arrayOf(
			PropTypes.object
		),
	}).isRequired,
	errors: PropTypes.shape({
		title: PropTypes.string,
		salary_error: PropTypes.string,
		bank_account: PropTypes.string,
		personal_code: PropTypes.string,
		insurance_nr: PropTypes.string,
		reporter_id: PropTypes.string,
		receives_log_emails: PropTypes.string,
		start_date: PropTypes.string,
		end_date: PropTypes.string,
		currency: PropTypes.string,
		domestic_salary: PropTypes.string,
	}),
	selectedUser: PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.string
	}),
	currencies: PropTypes.arrayOf(
		PropTypes.object
	).isRequired,
	onChange: PropTypes.func.isRequired,
	onCheckboxChange: PropTypes.func.isRequired,
	onSelectChange: PropTypes.func.isRequired,
	onAsyncChange: PropTypes.func.isRequired,
	handleAsyncSearch: PropTypes.func.isRequired,
	onWorkDateChange: PropTypes.func,
};

export default EmployeeFields;


// WEBPACK FOOTER //
// ./src/components/forms/users/fields/EmployeeFields.js